import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stretch-line",
  "use": "icon-stretch-line-usage",
  "viewBox": "0 0 1390 5",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1390 5\" id=\"icon-stretch-line\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1389.13 4.539H.036V.897H1389.13V4.54Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol